import React from 'react';
import ReactDOM from 'react-dom/client';
import GearForce from './GearForce';

const $root: HTMLElement | null = document.getElementById(
  'timken-tool-gear-force',
);

if ($root) {
  ReactDOM.createRoot($root).render(
    <React.StrictMode>
      <GearForce />
    </React.StrictMode>
  );
}
